import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const SearchParadan = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            PD_note,
            AddProChange,
            PD_getParaDataBySearchMoney,
            PD_joredraw,
            PD_qardekonID,
            PD_qardekon$,
            PD_qardekonRR,
            PD_getIsChecked,
            PD_getkasDataBySearchMoney,
            PD_zhmara,
            Ap_kasakan,
            PD_nawebarez,
            PD_isChecked,
            PD_peshandaniQarzyPeshw,
            PD_Change_R_Dolar, PD_del_dis,
            PD_nrx_Remembe, PD_Kren_Remembe,
            PD_Change_Dinar_to_R,
            PD_nrx_dolar_2,
            PD_nrx_Remembe_2,
            PD_Kren_dinar_2,
            PD_peshandaniQarzyPeshw_kon, PD_search_wasl,
            P_Amount_Dolar,
            P_High_Dolar,
            P_Low_Dolar,
            P_Amount_Dinar,
            P_Remebi_Price,
            P_DolartoRemembi_WithOut_Balance,
            P_DolartoDinar,
            P_DinartoRemembi_Without_Balance
          } = value;
          const wakilakn = Ap_kasakan.filter((user) => {
            return user.Name.trim().startsWith(PD_nawebarez);
          }).map((item, index) => {
            return (
              <option className="fk" key={index}>
                {item.Name}
              </option>
            );
          });
          return (
            <>
              <div
                className="card card-primary text-warning font-weight-bold"
                style={{ backgroundColor: "#2C3539" }}
              >
                <div
                  className="card-header border-bottom border-warning"
                  style={{ backgroundColor: "#2C3539" }}
                >
                  <h3 className="card-title tc "> گەران بە دوای </h3>
                </div>

                <form>
                  <div className="card-body text-right">
                    <div className="form-group">
                      <label className="font-weight-bold f4">:پسوولە</label>
                      <input
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? PD_getParaDataBySearchMoney(event)
                            : null
                        }
                        type="text"
                        onChange={AddProChange}
                        value={PD_zhmara}
                        name="PD_zhmara"
                        className="form-control text-right font-weight-bold"
                        placeholder="...گەڕان"
                      />
                    </div>
                    <div className="form-group">
                      <label className="font-weight-bold f4">: وەکیل </label>
                      <select
                        className="form-control text-right font-weight-bold selectpicker pull-right "
                        onChange={AddProChange}
                        name="PD_nawebarez"
                        value={PD_nawebarez}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? PD_getkasDataBySearchMoney(event)
                            : null
                        }
                      >
                        <option className="ml5">Search</option>
                        {wakilakn}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="font-weight-bold f4">:تێبینی </label>
                      <input
                        type="text"
                        onChange={AddProChange}
                        value={PD_note}
                        name="PD_note"
                        className="form-control text-right font-weight-bold"
                        disabled={PD_del_dis ? true : null}
                        placeholder="...تێبینی"
                      />
                    </div>
                  </div>
                  {/* remembe */}
                  <div className="row text-right ">
                    <div className="col-2 mt4">
                      <button
                        className="btn btn-success mt1"
                        onClick={PD_Change_R_Dolar}
                        disabled={PD_del_dis ? true : null}
                      >
                        ok
                      </button>
                    </div>
                    <div className="col-5">
                      <label className="font-weight-bold text-warning f4">
                        : RRR نرخی
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="PD_nrx_Remembe"
                        onChange={AddProChange}
                        disabled={PD_del_dis == true ? true : null}
                        value={PD_nrx_Remembe == 0 ? "" : PD_nrx_Remembe}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                    <div className="col-5">
                      <label className="font-weight-bold text-warning f4">
                        : RRR کڕینی
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="PD_Kren_Remembe"
                        onChange={AddProChange}
                        disabled={PD_del_dis == true ? true : null}
                        value={PD_Kren_Remembe == 0 ? "" : PD_Kren_Remembe}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="row text-right ">

                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : IQDبڕی پارە
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="P_Amount_Dinar"
                        onChange={AddProChange}
                        disabled={PD_del_dis == true ? true : null}
                        value={P_Amount_Dinar}
                        className="form-control text-right text-white font-weight-bold bg-danger"
                      />
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : دۆلار گران
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="P_High_Dolar"
                        onChange={AddProChange}
                        disabled={PD_del_dis == true ? true : null}
                        value={P_High_Dolar}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        :$بڕی پارە
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="P_Amount_Dolar"
                        onChange={AddProChange}
                        disabled={PD_del_dis == true ? true : null}
                        value={P_Amount_Dolar}
                        className="form-control text-right text-white font-weight-bold bg-success"
                      />
                    </div>

                    <div className="col-4 row">
                      <div className="col-4 mt4">
                        <button
                          className="btn btn-warning mt1"
                          onClick={P_DinartoRemembi_Without_Balance}
                          disabled={PD_del_dis == true ? true : null}
                        >
                          ok
                        </button>
                      </div>
                      <div className="col-4 mt4">
                        <button
                          className="btn btn-success mt1"
                          onClick={P_DolartoRemembi_WithOut_Balance}
                          disabled={PD_del_dis == true ? true : null}
                        >
                          $
                        </button>
                      </div>
                      <div className="col-4 mt4">
                        <button
                          className="btn btn-danger mt1"
                          onClick={P_DolartoDinar}
                          disabled={PD_del_dis == true ? true : null}
                        >
                          IQD
                        </button>
                      </div>
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : RRR نرخی
                      </label>
                      <NumberFormat
                        displayType="input" 
                        thousandSeparator={true}
                        name="P_Remebi_Price"
                        onChange={AddProChange}
                        disabled={PD_del_dis == true ? true : null}
                        value={P_Remebi_Price}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                    <div className="col-4">
                      <label className="font-weight-bold text-warning ">
                        : دۆلار هەرزان
                      </label>
                      <NumberFormat
                        displayType="input"
                        thousandSeparator={true}
                        name="P_Low_Dolar"
                        onChange={AddProChange}
                        disabled={PD_del_dis == true ? true : null}
                        value={P_Low_Dolar}
                        className="form-control text-right font-weight-bold"
                      />
                    </div>


                  </div>


                  <br />

                  <div className="col-12 text-right ml5">
                    <table id="non">
                      <thead>
                        <tr>
                          <th className="text-right pb-2 text-warning f4">
                            <input
                              onChange={PD_getIsChecked}
                              checked={PD_isChecked == true ? true : false}
                              value={PD_isChecked}
                              type="checkbox"
                              className="mr3"
                            />
                            :پیشاندانی قەرزی پێشوو
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {PD_isChecked == true ? (
                          <>
                            <tr>
                              <td className="text-right">
                                <label className="font-weight-bold text-warning f4">
                                  : قەرزی کۆن
                                </label>
                                <NumberFormat
                                  value={
                                    PD_joredraw == "دۆلار"
                                      ? Number(PD_qardekon$).toFixed(2)
                                      : PD_joredraw == "دینار"
                                      ? Number(PD_qardekonID).toFixed(2)
                                      : Number(PD_qardekonRR).toFixed(2)
                                  }
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold"
                                  thousandSeparator={true}
                                  prefix={
                                    PD_joredraw == null
                                      ? ""
                                      : PD_joredraw == "دۆلار"
                                      ? "$"
                                      : PD_joredraw == "دینار"
                                      ? "ID"
                                      : "R"
                                  }
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="text-right ">
                                <label className="font-weight-bold text-warning f4">
                                  :قەرزی ئێستا
                                </label>
                                <NumberFormat
                                  value={PD_peshandaniQarzyPeshw_kon(PD_joredraw)}
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold"
                                  thousandSeparator={true}
                                  prefix={
                                    PD_joredraw == null
                                      ? ""
                                      : PD_joredraw == "دۆلار"
                                      ? "$"
                                      : PD_joredraw == "دینار"
                                      ? "ID"
                                      : "R"
                                  }
                                />
                              </td>
                            </tr>
                          </>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="card-footer"
                    style={{ backgroundColor: "#2C3539" }}
                  ></div>
                </form>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default SearchParadan;
